// /**
//  * Convierte una fecha ISO (ej. "2025-09-30T21:03:12") 
//  * al formato "30/09/2025 21:03:12 hrs." (hora del servidor)
//  *
//  * @param {string} isoDate - Fecha en formato ISO.
//  * @returns {string} Fecha formateada.
//  */
// const FormatDateTime = (isoDate) => {
//   try {
//     debugger
//     if (!isoDate) return ""

//     const date = new Date(isoDate)

//     const day = String(date.getUTCDate()).padStart(2, "0")
//     const month = String(date.getUTCMonth() + 1).padStart(2, "0")
//     const year = date.getUTCFullYear()

//     const hours = String(date.getUTCHours()).padStart(2, "0")
//     const minutes = String(date.getUTCMinutes()).padStart(2, "0")
//     const seconds = String(date.getUTCSeconds()).padStart(2, "0")
//     debugger
//     return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} hrs.`
//   } catch {
//     return ''
//   }
// }

// ----- SelfieFan -----//

/**
 * Convierte una fecha ISO (ej. "2025-09-30T21:03:12") 
 * al formato "30/09/2025 21:03:12 hrs." (hora local del usuario que descarga)
 *
 * @param {string} isoDate - Fecha en formato ISO.
 * @returns {string} Fecha formateada.
 */
const FormatDateTimeToDownloadImages = (isoDate) => {
  try {
    if (!isoDate) return ""

    const date = new Date(isoDate)

    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const year = date.getFullYear()

    const hours = String(date.getHours()).padStart(2, "0")
    const minutes = String(date.getMinutes()).padStart(2, "0")
    const seconds = String(date.getSeconds()).padStart(2, "0")
    
    return `${day}${month}${year}_${hours}${minutes}${seconds}`
  } catch {
    return ''
  }
}

// ----- SelfieFan -----//

export { FormatDateTimeToDownloadImages }; //FormatDateTime